<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>مرتجع مبيعات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
          هنا يتم عرض جميع مرتجعات المبيعات
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                      <label>الفرع</label>
                      <select class="form-control"  v-model="branch_id">
                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>

                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='form-group col-lg-2 col-sm-2'>
                  <label>الحالة:</label>
                  <select class="form-control" style="padding: 0px" v-model="status">
                    <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                          <b> عرض </b>
                        </button>
                    </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>الكود</th>
                    <th style='text-align: center'>الاسم</th>
                    <th style='text-align: center'>المنتج</th>
                    <th style='text-align: center'>التاريخ</th>
                    <th style='text-align: center'>الرصيد</th>
                    <th style='text-align: center'>الفنى</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>
                    <td align='center'>{{index + 1}}</td>
                    <td align='center'>{{record.rec_id}}</td>
                    <td align='center'>{{record.customer_name}}</td>
                    <td align='center'>{{record.item}}</td>
                    <td align='center'>{{record.date}}</td>
                    <td align='center'>{{record.balance}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>
                      <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='col-lg-3 col-sm-3'>
                  <label>الفنى:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.technical_id">
                    <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                      {{ technical.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-sm-3' >
                  <label>المخزن:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.store_id">
                    <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                      {{ store.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='dismantlingTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div style="padding-top:25px" class='col-lg-3 col-md-3 col-sm-3'>
                    <button @click='saveData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                      <b> حفظ </b>
                    </button>
                </div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>

                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الصنف</th>
                      <th style='text-align: center'>الاسم</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record, index) in returnItems' :key='record.id'>
                      <td align='center'>{{index + 1}}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>
                        <input :id="index" type="checkbox" :value="record.id" v-model="selecteditems">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'SalesReturns',
  data () {
    return {
      dismantlingTitle: 'التاريخ',
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      selecteditems: [],
      validationErrors: '',
      technicals: {},
      branches: {},
      branch_id: '',
      records: [],
      items: [],
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: '',
      amount: '',
      item_id: '',
      stores: {},
      store_id: '',
      status: 0,
      types: [{id: 0, name: 'تحت الطلب'}, {id: 1, name: 'تم استلام الفنى'}, {id: 2, name: 'تم استلام المخزن'}, {id: 3, name: 'تم التفكيك'}]
    }
  },
  computed: {
    returnItems () {
      return this.items.filter(item => item.is_contract === 0)
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.changeBranche()
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.technicals = this.branches[i].technicals
        this.stores = this.branches[i].stores
      }
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getSalesReturn', {
        token: localStorage.getItem('token'),
        branche_id: this.branch_id,
        from_date: this.date_from,
        to_date: this.date_to,
        status: this.status
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branche_id': this.branch_id, 'invoic_id': '', 'invoic_date': '', 'vendor_id': '', 'storekeeper_id': '', 'vendor_invoice_id': '', 'vendor_invoice_date': '', 'status': '0', 'notes': ''}
        this.changeBranche()
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branche_id': recID.branche_id, 'invoic_id': recID.invoic_id, 'invoic_date': recID.invoic_date, 'vendor_id': recID.vendor_id, 'storekeeper_id': recID.storekeeper_id, 'vendor_invoice_id': recID.vendor_invoice_id, 'vendor_invoice_date': recID.vendor_invoice_date, 'status': recID.status, 'notes': recID.notes}
        this.changeBranche()
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + '...', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        selecteditems: this.selecteditems
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.record = res.data
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.record = res.data
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
            this.$refs.item_id.focus()
          }
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deletePurchaseMasters', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/SalesReturns.vue